export default __webpack_public_path__ + "static/logo_taf-8babb3a4e7ce085a23cfe88ccc8757cd.png";